/**
 * Campus Framework API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@bitapp.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum UserRole {
    Admin = 'admin',
    CaAdm = 'CA-ADM',
    CaVis = 'CA-VIS',
    CaSvi = 'CA-SVI',
    CaGes = 'CA-GES',
    CaFad = 'CA-FAD',
    CaKtv = 'CA-KTV',
    CaStp = 'CA-STP',
    CaSgc = 'CA-SGC',
    CaRec = 'CA-REC',
    CaOpa = 'CA-OPA',
    CaCob = 'CA-COB',
    CeSgc = 'CE-SGC',
    CeEvt = 'CE-EVT',
    CeStp = 'CE-STP',
    CeKtv = 'CE-KTV',
    CeFad = 'CE-FAD',
    CeAdm = 'CE-ADM',
    CeVis = 'CE-VIS',
    CoAm = 'CO-AM',
    CoDm = 'CO-DM',
    CoRm = 'CO-RM',
    CoGm = 'CO-GM',
    CoPb = 'CO-PB',
    CoTfa = 'CO-TFA',
    CoAds = 'CO-ADS',
    CoAdm = 'CO-ADM',
    CoVis = 'CO-VIS',
    CoSvi = 'CO-SVI',
    CoAvi = 'CO-AVI',
    CoApb = 'CO-APB',
    CoGca = 'CO-GCA'
};

